import {IChapterCue} from '@utils/parseChapterMarks';

export const getCueWidthPercent = (cue: IChapterCue, duration: number) =>
    ((cue.endTime - cue.startTime) / duration) * 100;

export const getCueFillPercent = (
    cue: IChapterCue,
    currentTime: number | null,
) => {
    if (currentTime === null || currentTime <= cue.startTime) {
        return 0;
    }

    if (currentTime >= cue.endTime) {
        return 100;
    }

    return (
        ((currentTime - cue.startTime) / (cue.endTime - cue.startTime)) * 100
    );
};

export const getProgressPercentage = (currentTime: number, duration: number) =>
    Math.min((currentTime / duration) * 100, 100);
